export default [
  '1.DXマインド',
  '2.ブランディング',
  '3.DX戦略立案',
  '4.既存事業変革',
  '5.新規事業開発',
  '6.事業継続',
  '回答確認',
];
